import { useState  } from "react";
import type {MouseEvent} from "react";
import { useQueryClient } from "@tanstack/react-query";

import { ArchiveIcon, Button } from "~/common/components";
import { BUTTON_VARIANTS } from "~/common/constants";
import { Patient } from "~/common/utils";
import { ArchivePatientModal } from "~/providers/components";
import { useIsTeamMemberStaff } from "~/providers/hooks";
import { patientCanBeArchived } from "~/providers/utils";

interface ConsultationRequestsTableActionsCellProps {
  patient: Patient;
}

export const ConsultationRequestsTableActionsCell = ({
  patient,
}: ConsultationRequestsTableActionsCellProps) => {
  const [showArchivePatient, setShowArchivePatient] = useState(false);
  const { isStaff } = useIsTeamMemberStaff();
  const queryClient = useQueryClient();

  const toggleShowArchivePatientModal = (event?: MouseEvent) => {
    event?.stopPropagation();
    setShowArchivePatient((prev) => !prev);
  };

  const handleArchiveSuccessfully = async () => {
    await queryClient.invalidateQueries({
      queryKey: ["getPatients"],
    });
    toggleShowArchivePatientModal();
  };

  if (isStaff || !patientCanBeArchived(patient)) {
    return null;
  }

  return (
    <>
      <Button
        className="flex w-fit items-center justify-center rounded-md border border-gray-30 p-2 hover:bg-gray-200"
        variant={BUTTON_VARIANTS.outline_none}
        onClick={toggleShowArchivePatientModal}
      >
        <ArchiveIcon className="size-3" />
      </Button>
      <ArchivePatientModal
        show={showArchivePatient}
        onClose={toggleShowArchivePatientModal}
        patient={patient}
        handleArchiveSuccessfully={handleArchiveSuccessfully}
      />
    </>
  );
};
